// CSV: lettura (con virgolette, righe a capo nei campi e delimitatore riconosciuto
// da solo) e scrittura. Il file esportato ha il BOM UTF-8 e il punto e virgola
// come separatore, così si apre correttamente anche in Excel in italiano.

import { downloadText } from './kernelDownload';

export { downloadText };

const DELIMITERS = [';', ',', '\t'];

/** Sceglie il delimitatore più frequente nella prima riga (fuori dalle virgolette). */
export const detectDelimiter = (text) => {
  const firstLine = text.split(/\r?\n/)[0] || '';
  let best = ';';
  let bestCount = -1;
  DELIMITERS.forEach((d) => {
    let inQuotes = false;
    let count = 0;
    for (const ch of firstLine) {
      if (ch === '"') inQuotes = !inQuotes;
      else if (ch === d && !inQuotes) count += 1;
    }
    if (count > bestCount) {
      best = d;
      bestCount = count;
    }
  });
  return best;
};

/** Righe di un CSV come array di array di stringhe (righe completamente vuote escluse). */
export const parseCsv = (input, forcedDelimiter) => {
  const text = input.replace(/^﻿/, '');
  const delimiter = forcedDelimiter || detectDelimiter(text);
  const rows = [];
  let row = [];
  let field = '';
  let inQuotes = false;

  for (let i = 0; i < text.length; i += 1) {
    const ch = text[i];
    if (inQuotes) {
      if (ch === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i += 1;
        } else {
          inQuotes = false;
        }
      } else {
        field += ch;
      }
    } else if (ch === '"') {
      inQuotes = true;
    } else if (ch === delimiter) {
      row.push(field);
      field = '';
    } else if (ch === '\n' || ch === '\r') {
      if (ch === '\r' && text[i + 1] === '\n') i += 1;
      row.push(field);
      field = '';
      rows.push(row);
      row = [];
    } else {
      field += ch;
    }
  }
  if (field !== '' || row.length > 0) {
    row.push(field);
    rows.push(row);
  }
  return rows.filter((r) => r.some((cell) => cell.trim() !== ''));
};

export const csvEscapeField = (value, delimiter) => {
  const text = value === null || value === undefined ? '' : String(value);
  return text.includes('"') || text.includes('\n') || text.includes('\r') || text.includes(delimiter)
    ? `"${text.replace(/"/g, '""')}"`
    : text;
};

/** Testo CSV (con BOM) da un array di righe. */
export const toCsv = (rows, delimiter = ';') => `﻿${rows.map((r) => r.map((c) => csvEscapeField(c, delimiter)).join(delimiter)).join('\r\n')}\r\n`;

/** Scarica le righe come file CSV (BOM + punto e virgola, apribile in Excel italiano). */
export const downloadCsv = (filename, rows, delimiter = ';') => downloadText(filename, toCsv(rows, delimiter));

/** Righe incollate da Excel/Fogli: valori separati da tabulazione. */
export const parseClipboardTable = (text) => parseCsv(text, '\t');
